import CheckoutPageTemplate from './CheckoutPageTemplate';

export default CheckoutPageTemplate;
